import React from 'react';
import * as PropTypes from 'prop-types';
import A from '../A';
import ImageBox from '../ImageBox';
import Icon from '../Icon';
import { imgUrlTransform } from '../../util-lib/image';
import {
  renderReleaseDate, renderCount, isHot, isExpire, getAuthorName, getHighlight
} from '../../util-lib/discount-headline';
import './style.scss';

const HeadlineItem = (
  {
    data,
    onShare,
    onLike,
    onUnlike,
    onClick
  }
) => {
  const {
    articleId, title, author, reviewCount, coverImage, share, detailUrl,
    releaseTime, tags, highlight, likes, liked
  } = data;
  const image = coverImage
    ? imgUrlTransform(coverImage, { both: '624x468' })
    : '';
  const hot = isHot(tags);
  const expire = isExpire(tags);
  const handleClick = () => {
    if (!onClick) {
      return;
    }
    onClick.call(null, articleId);
  };

  return (
    <A tag="li" className="dhl-item" href={detailUrl} onClick={handleClick}>
      {
        expire && <span className="expire-tag" />
      }
      <div className="dhl-item-title-and-image">
        <div className="dhl-item-title-and-highlight">
          <h2 className="dhl-item-title">
            {
              hot && <span className="hot-tag">火爆</span>
            }
            {title}
          </h2>
          {
            !!highlight && (
              <p className="dhl-item-highlight">
                {getHighlight(highlight)}
              </p>
            )
          }
        </div>
        <div className="dhl-item-image">
          <ImageBox loadAtOnce image={image} />
        </div>
      </div>
      <div className="dhl-item-author-and-date-and-share">
        <div className="dhl-item-author-and-date">
          <div className="dhl-item-author">{getAuthorName(author.userName || '探途老司机')}</div>
          <div className="dhl-item-dot" />
          <div className="dhl-item-date">{renderReleaseDate(releaseTime)}</div>
        </div>
        <div className="dhl-item-view">
          <Icon name="eye" className="icon-eye" />
          <span>{renderCount(reviewCount)}</span>
        </div>
        <div
          className="dhl-item-like"
          onClick={
            liked
              ? (e) => {
                e.stopPropagation();
                onUnlike.call(null, articleId);
              }
              : (e) => {
                e.stopPropagation();
                onLike.call(null, articleId);
              }
          }
        >
          {
            liked ? (
              <Icon name="liked" className="icon-liked" />
            ) : (
              <Icon name="like" className="icon-like" />
            )
          }
          <span>{renderCount(likes)}</span>
        </div>
        <div
          className="dhl-item-share"
          onClick={
            (e) => {
              e.stopPropagation();
              onShare({
                shareTitle: share.title,
                shareContent: share.description,
                shareUrl: detailUrl,
                shareImg: share.image
              }, articleId);
            }
          }
        >
          {
            liked ? (
              <Icon name="wechat" className="icon-wechat" />
            ) : (
              <Icon name="share" className="icon-share" />
            )
          }
        </div>
      </div>
    </A>
  );
};

HeadlineItem.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onShare: PropTypes.func.isRequired,
  onLike: PropTypes.func.isRequired,
  onUnlike: PropTypes.func.isRequired,
  onClick: PropTypes.func
};

export default HeadlineItem;
